import React from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { useFocusManager as $9bf71ea28793e738$export$10c5169755ce7bd7 } from '../../../../../../node_modules/@react-aria/focus/dist/FocusScope.mjs.js';
var NavbarMobileMenuToggleButton = React.forwardRef(function (_ref, ref) {
  var menuOpen = _ref.menuOpen,
      setMenuOpen = _ref.setMenuOpen;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var focusManager = $9bf71ea28793e738$export$10c5169755ce7bd7();

  var handleKeyDown = function handleKeyDown(e) {
    if (!focusManager) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        focusManager.focusNext({
          wrap: true
        });
        break;

      case 'ArrowUp':
        e.preventDefault();
        focusManager.focusPrevious({
          wrap: true
        });
        break;

      case 'End':
        e.preventDefault();
        focusManager.focusLast({});
        break;

      case 'Home':
        e.preventDefault();
        focusManager.focusFirst({});
        break;
    }
  };

  return React.createElement("button", {
    ref: ref,
    "aria-label": menuOpen ? 'Close menu' : 'Open menu',
    className: "helix-unified-nav__navigation-item helix-unified-nav__mobile-menu-trigger ".concat(menuOpen ? 'active' : ''),
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    onClick: function onClick() {
      setMenuOpen();
    }
  }, React.createElement(NavbarHelixIcon, {
    iconName: menuOpen ? 'close' : 'menu'
  }));
});
NavbarMobileMenuToggleButton.displayName = 'NavbarMobileMenuToggleButton';
export { NavbarMobileMenuToggleButton as default };